import { BaseError } from "@/domains/errors/kinds/BaseError";

export class ValidationError extends BaseError {
  constructor({ message, originalError }: { message: string; originalError?: Error }) {
    super({ message, originalError });
  }
}
